import UsersPage from '../components/UsersPage';

export default function CustomersPage() {
  return (
    <UsersPage
      title="Customers"
      subtitle="Search and manage customer accounts."
      userType="customer"
    />
  );
}
